import { Box, Button } from "@mui/material";
import { MaterialReactTable } from 'material-react-table'
import React, { useState } from "react";
import { db } from "../../../api/firebase";
import ArrayToCSV from "../../../components/ArrayToCSV/ArrayToCSV";
function TrayTable(props) {
  const [open, setOpen] = useState(false);
  const [history, setHistory] = useState([]);
  // const [paymentModalOpen, setPaymentModalOpen] = useState(false); // State variable for payment modal visibility

  const openPopup = async () => {
    try {
      const paymentRef = db.collection("Payment").doc("90158");
      const paymentDoc = await paymentRef.get();

      if (!paymentDoc.exists) {
        console.log("Payment document does not exist");
        return;
      }

      const paymentData = paymentDoc.data();
      const paymentHistory = paymentData.history || [];
      setHistory(paymentHistory);
    } catch (error) {
      console.error("Error fetching payment history:", error);
      // Handle the error here, e.g. display an error message to the user
    }
  };

  const handleAddPayment = () => {
    props.setPaymentModalOpen(true);
  };

  // const handleClosePaymentModal = () => {
  //   setPaymentModalOpen(false);
  // };

  return (
    <>
      <MaterialReactTable
        displayColumnDefOptions={{
          "mrt-row-actions": {
            muiTableHeadCellProps: {
              align: "center",
            },
            size: 120,
          },
        }}
        columns={props.columns}
        data={props.tableData}
        editingMode="modal" //default
        enableColumnOrdering
        enableEditing
        onEditingRowSave={props.handleSaveRowEdits}
        onEditingRowCancel={props.handleCancelRowEdits}
        renderRowActions={() => (
          <Box
            sx={{
              display: "flex",
              gap: "1rem",
            }}
          >
            {/* <Tooltip arrow placement="left" title="History">
              <IconButton onClick={openPopup} style={{ marginLeft: "80px" }}>
                <VisibilityIcon />
              </IconButton>
            </Tooltip> */}
            {history.length > 0 && (
              <div className="popup">
                <div className="popup-content">
                  <button
                    className="close-button"
                    onClick={() => setHistory([])}
                  >
                    Close
                  </button>
                  <ul>
                    {history.map((item, index) => (
                      <li key={index}>{JSON.stringify(item)}</li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </Box>
        )}
        renderTopToolbarCustomActions={() => (
          <Box>
            <ArrayToCSV
              data={props.tableData}
              csvFileName={props.csvFileName}
            />

            <Button
              onClick={() => props.setCreateModalOpen(true)}
              variant="contained"
              style={{
                marginLeft: "10px",
              }}
            >
              CREATE NEW ACCOUNT
            </Button>
            <Button
              onClick={handleAddPayment} // Open the payment modal
              style={{
                backgroundColor: "#1976D2",
                color: "white",
                marginLeft: "10px",
                // marginTop: "3px",
              }}
            >
              Return Tray
            </Button>
          </Box>
        )}
      />
    </>
  );
}

export default TrayTable;
